import { To } from 'react-router-dom'

import { Avatar, Box, Card, Circle, Tag, Text } from '@factorialco/deprecated-design-system'
import { PerformanceProcessEvaluationCardFragment } from 'generated/resources/graphql'

import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

import { tagColor, tagLabel } from 'modules/performance_process/lib/answerTag'

import { colorPicker } from '../filters/colorPicker'
import { reviewTypePicker } from '../filters/reviewTypePicker'

export const EvaluationCard: React.FC<{
  evaluation: PerformanceProcessEvaluationCardFragment
  showTag?: boolean
  to?: To
  isYou?: boolean
}> = ({ evaluation: { evaluationType, targetAccess, status }, to, isYou, showTag = true }) => (
  <Box minWidth="s300">
    <Card to={to}>
      <Card.Eyebrow>
        <Avatar
          size="s32"
          label="Avatar"
          url={targetAccess?.avatar ? buildUrl(targetAccess?.avatar) : undefined}
        />

        {showTag ? (
          <Tag leftItem="circle" inline capitalize type={tagColor(status)}>
            {tagLabel(status)}
          </Tag>
        ) : undefined}
      </Card.Eyebrow>
      <Card.Title>
        {`${targetAccess?.fullName}${
          isYou ? ' (' + i18n.t('performance_process.reviews.target_you') + ')' : ''
        }`}
      </Card.Title>
      <Card.Content>
        {evaluationType && (
          <Box flexDirection="row" key={evaluationType} gap="s16">
            <Box alignSelf="center">
              <Circle color={colorPicker(evaluationType)} size={16} />
            </Box>
            <Text.Normal>{reviewTypePicker(evaluationType)}</Text.Normal>
          </Box>
        )}
      </Card.Content>
    </Card>
  </Box>
)
